import i18next from 'i18next'
import { declensionByNum } from 'www/utils'
import getUserLanguage from 'src/utils/getUserLanguage'
import { YEAR_CASES } from 'www/constants/wordCases'

const currentLanguageIso = getUserLanguage()
const options = { ns: currentLanguageIso }

function getAgeLimitCaseText(limit) {
  const ageLimitCase = declensionByNum(limit, YEAR_CASES.genitive)
  const translatedAgeLimitCase = i18next.t(ageLimitCase, options)

  return `\u00A0${limit}\u00A0${translatedAgeLimitCase}`
}

function getSpecialityAgesText({ min, max }) {
  let agesString = ''

  const prefix = {
    from: 'от',
    till: 'до',
  }

  prefix.from = i18next.t(prefix.from, options)
  prefix.till = i18next.t(prefix.till, options)

  if (min || max) {
    const ageLimitsStrings = []

    if (min) {
      ageLimitsStrings.push(`${prefix.from}${getAgeLimitCaseText(min)}`)
    }

    if (max) {
      ageLimitsStrings.push(`${prefix.till}${getAgeLimitCaseText(max)}`)
    }

    agesString = ` ${ageLimitsStrings.join(' ')}`
  }

  return agesString
}

export default getSpecialityAgesText
